/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Fields/view.blocks to change it.
import Description from './Description/index'
import EmailAddress from './EmailAddress/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Fields({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/ContactInfo/Postal/NewAddress/Content/NewRelation/Add/Content/Email/Fields"
  
}) {
  return (<React.Fragment
>
<div
  data-testid="Fields.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<EmailAddress
  viewPath={`${viewPath}/EmailAddress`}
/>
<Description
  viewPath={`${viewPath}/Description`}
/>
</div>
{children}
</React.Fragment>)
}